import React from 'react'

import { Form, Col } from '_zari/core'

const NombreSocioFormGroup = ({ iValue }) => {
  return (
    <>
      <Form.Group>
        <Form.Label text='PROVEEDOR' htmlFor='input-nombreSocio' md={2} />
        <Col md={10}>
          <Form.InputText disabled id='input-nombreSocio' defaultValue={iValue} />
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(NombreSocioFormGroup)
